// extracted by mini-css-extract-plugin
export var slideUp = "videoBackground-module--slideUp--8cf7a";
export var slideUpLarge = "videoBackground-module--slideUpLarge--6c079";
export var slowFade = "videoBackground-module--slowFade--5735c";
export var videoCover = "videoBackground-module--videoCover--6e793";
export var videoLoad = "videoBackground-module--videoLoad--94ccf";
export var videoNormal = "videoBackground-module--videoNormal--9b9d7";